module.exports = "/images/pencil.svg?10b183e991028345bde498ee5b170bb0";